import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Check if user has already made a choice
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleConditions = () => {
    // You can add navigation to privacy policy page here
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-black shadow-lg z-50">
      <div >
        <div className="flex justify-between items-center gap-2">
          <div className="flex-1 min-w-0 py-[10px] pl-2 md:pt-[20px] md:pb-[19px]">
            <p className="font-light text-14">
              {t('cookieConsent.message')}
            </p>
          </div>
          <div className="flex-shrink-0  pt-[18px] pb-[17px] pr-2 md:py-[10px] ">
            <button
              onClick={handleAccept}
              className="bg-black text-white pt-[10px] pb-[9px] w-[110px] md:w-[350px] px-4 text-14 font-normal transition-colors whitespace-nowrap"
            >
              {t('cookieConsent.accept')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;